import { STONE_REGIONS } from '../../constants/stone';
import { TAdfoxMapBannerConfigItem } from '../../types/adfoxMapBannerConfig';

/**
 * Баннер СТОУН должен показываться только в МиМО: если в конфиге
 * regionIds не заданы, подставляем дефолтные регионы, чтобы матчинг
 * по региону выполнялся всегда (иначе баннер утекает в другие регионы).
 */
export function withStoneRegionIds(item: TAdfoxMapBannerConfigItem): TAdfoxMapBannerConfigItem {
  if (item.regionIds.length > 0) {
    return item;
  }

  return { ...item, regionIds: STONE_REGIONS };
}
